import { MIME_TYPE_MAP } from './constants';

const ACCEPTS_PREFIX_STRING = 'Accepts ';

export const generateAcceptedMimeTypesString = (accept: string[]): string => {
    return (
        ACCEPTS_PREFIX_STRING +
        accept
            .map(item => {
                return MIME_TYPE_MAP[item] || item;
            })
            .join(', ')
    );
};

export const formatFileSize = (bytes: number): string => {
    if (bytes < 1024) return `${bytes} Bytes`;
    const units = ['KB', 'MB', 'GB', 'TB'];
    let size = bytes / 1000;
    let unitIndex = 0;

    while (size >= 1000 && unitIndex < units.length - 1) {
        size /= 1000;
        unitIndex++;
    }

    const formattedSize = unitIndex === 0 ? Math.floor(size) : size.toFixed(1);
    return `${formattedSize} ${units[unitIndex]}`;
};
